import React, { useContext } from 'react';

import Divider from '@gogame/ui/Divider';
import Box from '@gogame/ui/Box';
import { styled } from '@gogame/ui/styles';
import { DraggableDialogContext } from './DraggableDialogContext';
import { ActionBar } from '../ActionBar';

const Toolbar = styled(ActionBar)(({ theme }) => ({
  paddingLeft: theme.spacing(1.5),
  paddingRight: theme.spacing(1),
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),
  minHeight: 40,
  userSelect: 'none',
}));

export const DraggableDialogToolbar = ({ icon, title, primaryActions }) => {
  const { attributes, listeners } = useContext(DraggableDialogContext);
  return (
    <Box
      component={'div'}
      {...attributes}
      {...listeners}
      sx={{ cursor: 'move' }}
    >
      <Toolbar icon={icon} title={title} primaryActions={primaryActions} />
      <Divider />
    </Box>
  );
};
